import monthlyAttendnce from '@/api/monthly-attendnce'
import { baseState, baseMutations } from '@/store/mixins'
import Employee from '@/api/employee'
import moment from 'moment'
import branch from '@/api/branch'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}
export const mutations = {
  ...baseMutations
}
export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      attrubutes
    )
    return monthlyAttendnce.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getDepartment(context, data) {
    return monthlyAttendnce.department(data)
  },
  getHoliday(context, params) {
    return monthlyAttendnce.holiday({ params })
  },
  getEmployee(context, attributes = {}) {
    return Employee.get({
      params: Object.assign(
        {
          include: 'position,shift',

          fields: {
            setup_staff_information:
              'staff_id,name_en,name_kh,emp_id,gender,phone_number_1,date_of_birth,position_id,shift_id,photo,department_id',
            position: 'position_id,pos_name_en',
            shift: 'shift_id,shift_name,shift_type'
          },
          filter: {
            status_active: 'Active',
            department_id: attributes.department_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getBranch(context, attributes = {}) {
    return branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },

  getPosition(context, data) {
    return monthlyAttendnce.position(data)
  },
  getHeader(context, params) {
    return monthlyAttendnce.header({ params })
  },
  exportExcel(context, payload) {
    return monthlyAttendnce.exportExcel(payload)
  }
}
